import { Colore } from "./Colore";
import { Fase } from "./Fase";
import { Contenitore } from "./Contenitore";
import { InnerRigaDistinta } from "./InnerRigaDistinta";
import { VariazioneRigaDistinta } from './VariazioneRigaDistinta';
import { RigaDistintaQtaTaglia } from './RigaDistintaQtaTaglia';
import { StatoVariazioneRigaDistinta } from '.';
import { RigaDistintaPerComunicazioneVariazione } from './VariazioneDaComunicare';

export interface RigaDistinta {
    id: string;        
    indiceRiga: number;
    innerRigaDistinta: InnerRigaDistinta;
    coloreDecodificato: Colore;
    faseDecodificata: Fase;
    quantitaPerTaglia?: RigaDistintaQtaTaglia[];
    lineaVenditaCodice: string;
    lineaVenditaDescrizione: string;
    contenitoreDecodificato?: Contenitore;

    // Dati storici e consumi in caso di riga in distinta statica
    indiceVariazioneAttiva: number;
    variazioniComunicate?: VariazioneRigaDistinta[];
    statoSincronizzazioneVariazione?: StatoSyncRigaDistinta;
    eliminataDaAs400: boolean;
    contieneVariazioniDaValidare: boolean;
    variazioneGenerataDaValidazione: boolean;
    inAttesaDiSincronizzazione: boolean;
    conVariazioniConsolidate: boolean;
    richiestaDiInserimento: boolean;    
}

export enum StatoSyncRigaDistinta {
    STATO_SINCRONIZZAZIONE_VARIAZIONE_NEW = "NEW",
    STATO_SINCRONIZZAZIONE_VARIAZIONE_DA_COMUNICARE_AD_AS400 = "DA-COMUNICARE-AD-AS400",
    STATO_SINCRONIZZAZIONE_VARIAZIONE_SINCRONIZZATA_CON_AS400 = "SINCRONIZZATA_CON-AS400",
    STATO_SINCRONIZZAZIONE_VARIAZIONE_COMUNICATA_AD_AS400_MANUALMENTE = "SINCRONIZZATA_CON-AS400_MANUALMENTE"
}

// export const RigaDistintaHelper = {
//     variazioneInAttesaSync(riga: RigaDistinta | RigaDistintaPerComunicazioneVariazione): boolean {
//         let modificaInAttesaSync = riga.inAttesaDiSincronizzazione;
        
//         let inserimentoInAttesaSync = false;
//         if(riga.contieneVariazioniDaValidare && riga.variazioniComunicate != undefined && riga.variazioniComunicate.length > 0) {
//             let ultimaVariazione = riga.variazioniComunicate[riga.variazioniComunicate.length -1];
//             inserimentoInAttesaSync = ultimaVariazione.statoValidazione == StatoVariazioneRigaDistinta.RigaAggiuntaDalFornitore || ultimaVariazione.statoValidazione == StatoVariazioneRigaDistinta.RigaAggiuntaDaBC;
//         }
    
//         return modificaInAttesaSync || inserimentoInAttesaSync;
//     },
//     isNuova(riga: RigaDistinta) {
        
//         // TODO: sostituire con il check di stato quando lato server sarà omogeneo
//         //return riga.statoSincronizzazioneVariazione != 'NEW'; 
        
//         if(riga.contieneVariazioniDaValidare && riga.variazioniComunicate != undefined && riga.variazioniComunicate.length > 0) {
//             let ultimaVariazione = riga.variazioniComunicate[riga.variazioniComunicate.length -1];
//             let statoNuova = ultimaVariazione.statoValidazione == StatoVariazioneRigaDistinta.RigaAggiuntaDalFornitore || ultimaVariazione.statoValidazione == StatoVariazioneRigaDistinta.RigaAggiuntaDaBC;
  
//             return statoNuova;
//         }
  
//         return false;
//     }
// }